export const HorizontalStiffiners = {
    A: {
        d1: 200,
        D: 206.4,
        y1: 136.477300058188,
        y2: 69.9226999418116,
        I: 0.0000090875606639,
    },
    B: {
        d1: 200,
        D: 206.4,
        y1: 136.477300058188,
        y2: 69.9226999418116,
        I: 0.0000090875606639,
    },
    C: {
        d1: 200,
        D: 206.4,
        y1: 136.477300058188,
        y2: 69.9226999418116,
        I: 0.0000090875606639,
    },
    D: {
        d1: 200,
        D: 206.4,
        y1: 136.477300058188,
        y2: 69.9226999418116,
        I: 0.0000090875606639,
    },
    E: {
        d1: 200,
        D: 206.4,
        y1: 136.477300058188,
        y2: 69.9226999418116,
        I: 0.0000090875606639,
    },
}

export const VerticalStiffiners = {
    A: {
        d1: 100,
        D: 106.4,
        y1: 63.3537923802866,
        y2: 43.0462076197134,
        I: 0.00000098873536623511,
    },
    B: {
        d1: 100,
        D: 106.4,
        y1: 63.3537923802866,
        y2: 43.0462076197134,
        I: 0.00000098873536623511,
    },
    C: {
        d1: 100,
        D: 106.4,
        y1: 63.3537923802866,
        y2: 43.0462076197134,
        I: 0.00000098873536623511,
    },
    D: {
        d1: 100,
        D: 106.4,
        y1: 63.3537923802866,
        y2: 43.0462076197134,
        I: 0.00000098873536623511,
    },
    E: {
        d1: 100,
        D: 106.4,
        y1: 63.3537923802866,
        y2: 43.0462076197134,
        I: 0.00000098873536623511,
    },
}
